import colors from '@scss/color-shades'
import locales from './locales.json'

export const DEFAULT_LANGUAGE = locales.default
export const LANGUAGES = locales.languages
export const STATUS_COLORS = {
  GREEN: colors.green,
  LIGHTBLUE: colors.primary,
  LIGHTGREEN: colors.light_green,
  RED: colors.red,
  GREY: colors.grey_dark,
}
export const RESULTS_REFRESH_MS = 10 * 1000

// COORDINATES [Lon, Lat]
export const COORDINATES_FRANKFURT = [8.6, 50.1]
export const COORDINATES_ORIGIN = COORDINATES_FRANKFURT

export const GEOJSON_SIZE_LIMIT = 1024 ** 2

export const CREATE_ANALYSIS_STEPS = {
  ZONE: 'zone',
  SELECT_SOURCE: 'select-source',
  LINE: 'line',
  LAUNCH: 'launch',
}
